export interface IProductItemBasics {
    ID: number;
    Name: string;
    ModuleType: string;
}

export class ProductItemBasics implements IProductItemBasics {
    ID: number;
    Name: string;
    ModuleType: string;
}

export class ProductItemBasicsArray extends Array<ProductItemBasics>  {

    constructor(...items: ProductItemBasics[]) {
        super(...items);
        Object.setPrototypeOf(this, ProductItemBasics.prototype);
    }

}
